
import Swiper from 'swiper' // 스와이퍼 재선언 시 사용

import { pdMixin } from '@/mixin/pd/pdMixin'
import { pushBannerGtmData } from '~/utils/gtm'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    CommonImage
  },
  mixins: [pdMixin],
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          auto: false,
          loop: false,
          navigation: false,
          pagination: false
        }
      }
    },
    swiperData: {
      type: [Array, Number],
      default: () => {
        return []
      }
    },
    swiperType: {
      type: String,
      default: ''
    },
    freeSwiper: { // 넓이 가변 슬라이드, 넓이 부족할 시 슬라이드 destroy
      type: Boolean,
      default: false
    },
    activeSlide: { // 버튼 슬라이드 활성화용
      type: [Number, String],
      default: ''
    },
    position: { // 상품 상세 GTM 수집을 위한 배너의 위치 (상단: top, 중단: mid)
      type: String,
      default: ''
    },
  },
  data () {
    return {
      swiperOpt: {
        slidesPerView: 1,
        loop: true,
        lazy: true,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
          // nextEl: '#button-next-relacionados.swiper-button-next',
          // prevEl: '#button-prev-relacionados.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-wrap .swiper-pagination',
          clickable: true,
          type: 'fraction', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="hiddenText">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        freeMode: false,
        slidesPerColumn: 1,
        grid: {
          rows: 1
        }
      },
      autoStatus: true,
      isDestroy: false
    }
  },
  created () {
    // 자동롤링
    if (this.options.auto === false) {
      this.swiperOpt.autoplay = this.options.auto
      this.autoStatus = false
    } else if (typeof this.options.auto === 'number') {
      this.swiperOpt.autoplay.delay = this.options.auto
      this.autoStatus = false
    }

    // 무한루프
    if (this.options.loop === false) {
      this.swiperOpt.loop = this.options.loop
    }

    // 인디케이터
    if (this.options.pagination === 'fraction') {
      this.swiperOpt.pagination.type = this.options.pagination
    } else if (this.options.pagination === 'tab') {
      const tabInd = this.tabIndicator
      this.swiperOpt.pagination = {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets', // 버튼 디자인 bullets" / "fraction"
        renderBullet (index, className) {
          return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="">' + tabInd[index] + '</span></button>'
        }
      }
    }

    // freeMode
    if (this.options.freeMode === true) {
      this.swiperOpt.freeMode = this.options.freeMode
    }

    // slidesPerView
    if (this.options.slidesPerView !== undefined) {
      this.swiperOpt.slidesPerView = this.options.slidesPerView
    }

    // slidesPerColumn
    if (typeof this.options.slidesPerColumn === 'number') {
      this.swiperOpt.slidesPerColumn = this.options.slidesPerColumn
    }

    // slidesPerGroup
    if (typeof this.options.slidesPerGroup === 'number') {
      this.swiperOpt.slidesPerGroup = this.options.slidesPerGroup
    }

    // grid
    if (typeof this.options.grid === 'number') {
      this.swiperOpt.grid.rows = this.options.grid
    }

    // spaceBetween
    if (typeof this.options.spaceBetween === 'number') {
      this.swiperOpt.spaceBetween = this.options.spaceBetween
    }

    // direction
    if (this.options.direction === 'vertical') {
      this.swiperOpt.direction = this.options.direction
    }

    // console.log('swiperOptswiperOptswiperOpt', this.swiperOpt)
  },
  mounted () {
    if (this.swiperData.length === 1) {
      this.swiperDestroy()
    }
    if (this.swiperType === 'oneline') {
      this.$refs.swiperEl.swiper.allowTouchMove = false
    }
    if (this.freeSwiper) {
      this.swiperWidth()
      this.swiperDestroyFree('opt-swiper')
    }
  },
  methods: {
    stopSwiper () {
      console.log('stop', this.$refs.swiperEl)
      this.$refs.swiperEl.swiper.autoplay.stop()
      this.autoStatus = false
    },
    playSwiper () {
      console.log('play')
      this.$refs.swiperEl.swiper.autoplay.start()
      this.autoStatus = true
    },
    swiperDestroy () {
      this.$refs.swiperEl.swiper.destroy()
    },
    swiperWidth () { // 슬라이드 총 넓이
      const swiperItem = this.$refs.swiperEl.$el.querySelectorAll('.swiper-slide')
      let sum = 0
      swiperItem.forEach((item) => {
        sum += item.clientWidth
      })
      this.swiperTotalWidth = sum
    },
    swiperDestroyFree (swipeWrap) { // 슬라이드 제어
      this.swipeWrapWidth = document.getElementsByClassName(swipeWrap)[0].clientWidth

      if (this.swiperTotalWidth < this.swipeWrapWidth && this.isDestroy === false) {
        this.$refs.swiperEl.swiper.destroy()
        this.isDestroy = true
        console.log('destroy ' + this.isDestroy)
      } else if (this.swiperTotalWidth > this.swipeWrapWidth && this.isDestroy === true) {
        this.$refs.swiperEl.swiper = new Swiper(this.$refs.swiperEl.$el, this.swiperOpt)
        this.isDestroy = false
        console.log('destroy ' + this.isDestroy)
      }
    },
    slideBtnClick (e) {
      if (e.target.classList.contains('swiper-button-prev')) {
        this.$emit('slideMove', {
          direction: 'prev'
        })
      } else {
        this.$emit('slideMove', {
          direction: 'next'
        })
      }
    },
    moveLink (item, index) {
      console.log('banrLinkMvmnTyCd ===', item.banrLinkMvmnTyCd)
      if (this.isNotEmpty(item)) {
        let gtmItem = []

        // 상품 상세에서 배너 클릭 시 GTM 동작
        if (this.position !== '') {
          if (this.position === 'top') {
            gtmItem = {
              fileNm: '',
              bannerText: item?.name,
              index: index + 1,
              location: 'PC상품상세_띠 배너_2023082101'
            }
          } else {
            gtmItem = {
              fileNm: '',
              bannerText: item?.name,
              index: index + 1,
              location: 'PC상품상세_띠 배너_2023082102'
            }
          }

          pushBannerGtmData(gtmItem, true)
        }

        if (item.banrLinkMvmnTyCd === '02') {
          window.open(item?.link)
        } else {
          this.$router.push(item?.link)
        }
      }
    }
  }
}
